import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Button from "../../AdminModule/Dashboard/AdminDashboard/Button";
import ReactStars from "react-rating-stars-component";
import "./styles.scss";
import { postMentorFeedback } from "../../AdminModule/Dashboard/MentorDashboard/dependencies/action";
import swal from "sweetalert";
import {
  Typography,
  InputBase,
} from "@material-ui/core";

function StartupFeedbackModal(props) {
  let currentUserId= JSON.parse(localStorage.getItem("SavedLoggedInData")).id;
  const { postMentorFeedback, feedBackData, cohortSession,modelOverLap,cohortAdminId } = props;
  const [ratingData, setRatingData] = useState(0);
  const [ratingData2, setRatingData2] = useState(0);
  const [ratingData3, setRatingData3] = useState(0);
  const [ratingData4, setRatingData4] = useState(0);
  const [showError, setShowError] = useState(false);
  const [commentsToggle, setCommentsToggle] = useState(false);
  const [comments, setComments] = useState("");
  const handleClose = () => {
    props.setModalVisibility(false);
    setRatingData(0);
    setRatingData2(0);
    setRatingData3(0);
    setRatingData4(0);
    setComments("");
  };
  useEffect(() => {}, []);
  const handleSubmitInvitation = () => {
    if (
      ratingData !== 0 &&
      ratingData2 !== 0 &&
      ratingData3 !== 0 &&
      ratingData4 !== 0
    ) {
      setShowError(false);
      let params = {
        cohortGroupSessionId: props.cohortGroupId,
        userId: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
        overallSessionRating: ratingData2,
        speakerRating: ratingData,
        topicContentRating: ratingData3,
        qualityOfContentRating: ratingData4,
        comments: comments,
      };
      props.postFeedBack(params);
      setTimeout(() => {
    
        props.parentData(true);
        props.setModalVisibility(false);
        setRatingData(0);
        setRatingData2(0);
        setRatingData3(0);
        setRatingData4(0);
        setComments("");
     
      }, 1000);
    } else {
      setShowError(true);
    }
  };
  const handleSubmit = () => {
    if (
      ratingData !== 0 &&
      ratingData2 !== 0 &&
      ratingData3 !== 0 &&
      ratingData4 !== 0
    ) {
      setShowError(false);
      let params = {
        mentorId: currentUserId,
        startupId: props.startupId,
        mentorshipId: props.mentorshipId,
        overallRating: ratingData,
        mentorBehaviour: ratingData2,
        adviceAndGuidance: ratingData3,
        responsiveness: ratingData4,
        mentorshipStatus: "CLOSED",
      };
      postMentorFeedback(params);
      setTimeout(() => {
        swal({
          title: "Thank You",
          text: `StartUp Feedback Submitted Successfully`,
          icon: "success",
          
        }).then(function () {
          props.parentData(true);
          props.setModalVisibility(false);
          setRatingData(0);
          setRatingData2(0);
          setRatingData3(0);
          setRatingData4(0);
          setComments("");
        });
      }, 500);
    } else {
      setShowError(true);
    }
  };
  const firstExample = {
    size: 35,
    count: 5,
    isHalf: false,
    value:
      cohortSession &&
      cohortSession === true &&
      feedBackData !== undefined &&
      feedBackData !== ""
        ? feedBackData?.speakerRating
        : feedBackData !== undefined &&
          feedBackData !== null &&
          feedBackData !== ""
        ? feedBackData?.overallRating
        : 0,
    color: "lightgray",
    activeColor: "orange",
    onChange: (newValue) => {
      setRatingData(newValue);
    },
  };
  const secondExample = {
    size: 35,
    count: 5,
    isHalf: false,
    value:
      cohortSession &&
      cohortSession === true &&
      feedBackData !== undefined &&
      feedBackData !== ""
        ? feedBackData?.overallSessionRating
        : feedBackData !== undefined &&
          feedBackData !== null &&
          feedBackData !== ""
        ? feedBackData?.mentorBehaviour
        : 0,
    color: "lightgray",
    activeColor: "orange",
    onChange: (newValue) => {
      setRatingData2(newValue);
    },
  };
  const thirdExample = {
    size: 35,
    count: 5,
    isHalf: false,
    paddingLeft: 25,
    value:
      cohortSession &&
      cohortSession === true &&
      feedBackData !== undefined &&
      feedBackData !== ""
        ? feedBackData?.topicContentRating
        : feedBackData !== undefined &&
          feedBackData !== null &&
          feedBackData !== ""
        ? feedBackData?.adviceAndGuidance
        : 0,
    color: "lightgray",
    activeColor: "orange",

    onChange: (newValue) => {
      setRatingData3(newValue);
    },
  };
  const fourthExample = {
    size: 35,
    count: 5,
    isHalf: false,
    paddingLeft: 25,
    value:
      cohortSession &&
      cohortSession === true &&
      feedBackData !== undefined &&
      feedBackData !== ""
        ? feedBackData?.qualityOfContentRating
        : feedBackData !== undefined &&
          feedBackData !== null &&
          feedBackData !== ""
        ? feedBackData?.responsiveness
        : 0,
    color: "lightgray",
    activeColor: "orange",
    onChange: (newValue) => {
      setRatingData4(newValue);
    },
  };

  return (
    <>
      <div className="modal-dialog modal-dialog-centered">
        <Modal
          size="lg"
          show={props.modalVisibility}
          onHide={() => {
            props.setModalVisibility(false);
            setRatingData(0);
            setRatingData2(0);
            setRatingData3(0);
            setRatingData4(0);
            setComments("");
          }}
          aria-labelledby="example-modal-sizes-title-lg"
          style={{ borderRadius: "7px" }}
        >
          <Modal.Header className="d-flex " style={modelOverLap && modelOverLap === true ? {boxShadow:"0px -10px 5px #888"}:{}}>
            <Modal.Title className="modalHeading">
              {cohortSession && cohortSession === true
                ? "COHORT SESSION FEEDBACK"
                : "STARTUP FEEDBACK"}
            </Modal.Title>
            <div className="newuserTooltip">
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={handleClose}
              />
              <span
                className="tooltiptext  close-window"
                style={{ left: "-130px", top: "2px", width: "130px" }}
              >
                Close Window
              </span>
            </div>
          </Modal.Header>
          <Modal.Body 
          style={modelOverLap && modelOverLap === true ? {boxShadow:""}:{}}
          >
            {feedBackData && props?.viewMode ? ( // MODAL TO SHOW THE FEEDBACK
              <div className="feedback-rating feedBackModalFix modalfirZ">
                <div className="row ">
                  <div className="iconDiv">
                   
                    <div>1</div>
                  </div>
                  <div className="col col-lg-6 col-md-5 col-sm-10 col-10 rating-line modalHeadings78">
                    {cohortSession && cohortSession === true
                      ? "Overall Session Rating*"
                      : "Overall StartUp Rating*"}
                  </div>
                  <div
                    // style={{
                    //   textAlign: "left",
                    //   marginTop: "-15px",
                    //   marginLeft: "1.5rem",
                    // }}
                    className="col col-lg-5 col-md-6 col-sm-12  col-12 reactstart starPositionFix"
                  >
                    <ReactStars
                      value={feedBackData?.overallSessionRating}
                      edit={false}
                      size={35}
                      count={5}
                      isHalf={false}
                      color={"lightgray"}
                      activeColor={"orange"}
                    />
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="iconDiv">
                    <div>2</div>
                  </div>
                  <div className="col col-lg-6 col-md-5 col-sm-10 col-10 rating-line modalHeadings78">
                    {cohortSession && cohortSession === true
                      ? "Speaker/Speakers Rating*"
                      : "StartUp Behaviour & Professionalism*"}
                  </div>
                  <div
                    // style={{
                    //   textAlign: "left",
                    //   marginTop: "-15px",
                    //   marginLeft: "1.5rem",
                    // }}
                    className="col col-lg-5 col-md-6 col-sm-12  col-12 reactstart starPositionFix"
                  >
                    <ReactStars
                      value={feedBackData?.speakerRating}
                      edit={false}
                      size={35}
                      count={5}
                      isHalf={false}
                      color={"lightgray"}
                      activeColor={"orange"}
                    />
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="iconDiv">
                    <div>3</div>
                  </div>
                  <div className="col col-lg-6 col-md-5 col-sm-10 col-10 rating-line modalHeadings78">
                    {cohortSession && cohortSession === true
                      ? "Relevance of Topic/Content*"
                      : "StartUp Prepardness for Session*"}
                  </div>
                  <div
                    // style={{
                    //   textAlign: "left",
                    //   marginTop: "-15px",
                    //   marginLeft: "1.5rem",
                    // }}
                    className="col col-lg-5 col-md-6 col-sm-12  col-12 reactstart starPositionFix"
                  >
                    <ReactStars
                      value={feedBackData?.topicContentRating}
                      edit={false}
                      size={35}
                      count={5}
                      isHalf={false}
                      color={"lightgray"}
                      activeColor={"orange"}
                    />
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="iconDiv">
                    <div>4</div>
                  </div>
                  <div className="col col-lg-6 col-md-5 col-sm-10 col-10 rating-line modalHeadings78">
                    {cohortSession && cohortSession === true
                      ? "Quality of Content*"
                      : "Startup Business Plan Assessment*"}
                  </div>
                  <div
                    // style={{
                    //   textAlign: "left",
                    //   marginTop: "-15px",
                    //   marginLeft: "1.5rem",
                    // }}
                    className="col col-lg-5 col-md-6 col-sm-12  col-12 reactstart starPositionFix"
                  >
                    <ReactStars
                      value={feedBackData?.qualityOfContentRating}
                      edit={false}
                      size={35}
                      count={5}
                      isHalf={false}
                      color={"lightgray"}
                      activeColor={"orange"}
                    />
                    {showError && (
                      <div className="login-error-msg mt-2">
                        Please Rate All Parameters
                      </div>
                    )}
                  </div>
                </div>

                {cohortSession && cohortSession === true ? (
                  <div className="row mt-3" style={{ marginBottom: "1rem" }}>
                    <div className="iconDiv">
                      <div>5</div>
                    </div>
                    <div className="col col-lg-2 col-md-5 col-sm-10 col-10 rating-line modalHeadings78 ">
                      {"Comments"}
                    </div>
                    <div
                      // style={{
                      //   textAlign: "left",
                      //   marginTop: "4px",
                      //   marginLeft: "-0.75rem",
                      // }}
                      className="col col-lg-7 col-md-6 col-sm-12  col-12 reactstart vommebt"
                    >
                     
                      {feedBackData?.comments !== "" &&
                      feedBackData?.comments !== null ? (
                      
                        feedBackData?.comments?.length > 95 ? (
                          !commentsToggle ? (
                            <>
                              {" "}
                              <div
                                style={{
                                  border: "1px solid lightgray",
                                  padding: "7px",
                                  whiteSpace: "break-spaces",
                                  position:"relative",
                                  marginTop:"5px"
                                }}
                              >
                                {feedBackData?.comments.substring(0, 95) +
                                  " " +
                                  "..."}
                                <div
                                  onClick={() => {
                                    setCommentsToggle(true);
                                  }}
                                  style={{
                                    color: "#b499c7",
                                    fontSize: "18px",
                                    cursor: "pointer",
                                    fontWeight: "bold",
                                  }}
                                >
                                  View More
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              <div
                                style={{
                                  border: "1px solid lightgray",
                                  padding: "7px",
                                  whiteSpace: "break-spaces",
                                }}
                              >
                                {feedBackData?.comments}
                                <div
                                  onClick={() => {
                                    setCommentsToggle(false);
                                  }}
                                  style={{
                                    color: "#b499c7",
                                    fontSize: "18px",
                                    cursor: "pointer",
                                    fontWeight: "bold",
                                  }}
                                >
                                  View Less
                                </div>
                              </div>
                            </>
                          )
                        ) : (
                          <div
                            style={{
                              border: "1px solid lightgray",
                              padding: "7px",
                              whiteSpace: "break-spaces",
                              position:"relative",
                              marginTop:"5px"
                            }}
                          >
                            {feedBackData?.comments}
                          </div>
                        )
                      ) : (
                        <div
                        className="feedbackBlankComments"
                          // style={{
                          //   position: "relative",
                          //   top: "-0.35rem",
                          //   right: "-6.5rem",
                          //   display: "flex",
                          //   justifyContent: "space-evenly",
                          // }}
                        >
                          {" "}
                          - -
                        </div>
                      )}

                      {feedBackData && feedBackData !== null ? (
                        ""
                      ) : (
                        <Typography className="commentwordcount wordcountfont">
                          Word Count:{" "}
                          {comments?.length === 0
                            ? 0
                            : comments
                                ?.replace(/(^\s*)|(\s*$)/gi, "")
                                ?.replace(/[ ]{2,}/gi, " ")
                                ?.split(" ")?.length}
                          /100
                        </Typography>
                      )}
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            ) : (
              //MODAL TO CREATE THE FEEDBACK
              <div className="feedback-rating feedBackModalFix">
                <div className="row ">
                  <div className="iconDiv">
                    <div>1</div>
                  </div>
                  <div className="col col-lg-6 col-md-5 col-sm-10 col-10 rating-line modalHeadings78 ">
                    {cohortSession && cohortSession === true
                      ? "Overall Session Rating*"
                      : "Overall StartUp Rating*"}
                  </div>
                  <div
                    // style={{
                    //   textAlign: "left",
                    //   marginTop: "-15px",
                    //   marginLeft: "1.5rem",
                    // }}
                    className="col col-lg-5 col-md-6 col-sm-12  col-12 reactstart starPositionFix" 
                  >
                    <ReactStars {...secondExample} edit={true} />
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="iconDiv">
                    <div>2</div>
                  </div>
                  <div className="col col-lg-6 col-md-5 col-sm-10 col-10 rating-line modalHeadings78">
                    {cohortSession && cohortSession === true
                      ? "Speaker/Speakers Rating*"
                      : "StartUp Behaviour & Professionalism*"}
                  </div>
                  <div
                    // style={{
                    //   textAlign: "left",
                    //   marginTop: "-15px",
                    //   marginLeft: "1.5rem",
                    // }}
                    className="col col-lg-5 col-md-6 col-sm-12  col-12 reactstart starPositionFix"
                  >
                    <ReactStars {...firstExample} edit={true} />
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="iconDiv">
                    <div>3</div>
                  </div>
                  <div className="col col-lg-6 col-md-5 col-sm-10 col-10 rating-line modalHeadings78">
                    {cohortSession && cohortSession === true
                      ? "Relevance of Topic/Content*"
                      : "StartUp Prepardness for Session*"}
                  </div>
                  <div
                    // style={{
                    //   textAlign: "left",
                    //   marginTop: "-15px",
                    //   marginLeft: "1.5rem",
                    // }}
                    className="col col-lg-5 col-md-6 col-sm-12  col-12 reactstart starPositionFix"
                  >
                    <ReactStars {...thirdExample} edit={true} />
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="iconDiv">
                    <div>4</div>
                  </div>
                  <div className="col col-lg-6 col-md-5 col-sm-10 col-10 rating-line modalHeadings78">
                    {cohortSession && cohortSession === true
                      ? "Quality of Content*"
                      : "Startup Business Plan Assessment*"}
                  </div>
                  <div
                    // style={{
                    //   textAlign: "left",
                    //   marginTop: "-15px",
                    //   marginLeft: "1.5rem",
                    // }}
                    className="col col-lg-5 col-md-6 col-sm-12  col-12 reactstart starPositionFix"
                  >
                    <ReactStars {...fourthExample} edit={true} />
                    {showError && (
                      <div className="login-error-msg mt-2">
                        Please Rate All Parameters
                      </div>
                    )}
                  </div>
                </div>
                {cohortSession && cohortSession === true ? (
                  <div className="row mt-3">
                    <div className="iconDiv">
                      <div>5</div>
                    </div>
                    <div className="col col-lg-2 col-md-5 col-sm-10 col-10 rating-line modalHeadings78 ">
                      {"Comments"}
                    </div>
                    <div
                      // style={{
                      //   textAlign: "left",
                      //   marginTop: "4px",
                      //   marginLeft: "-0.75rem",
                      // }}
                      className="col col-lg-7 col-md-6 col-sm-12  col-12 reactstart vommebt"
                    >
                      <InputBase
                      className="inputbaseforares "
                        style={{
                          border: "1px solid rgba(0,0,0,0.3)",
                          padding: "10px",
                          fontFamily: "Montserrat",
                          borderRadius: "3px",
                          
                          position:"relative",
                          marginTop:"5px"
                        }}
                        rows={5}
                        maxRows={5}
                        value={
                          feedBackData && feedBackData !== null
                            ? feedBackData?.comments
                            : comments
                        }
                        onChange={(e) => {
                          const value = e.target.value;
                          const newData = value.replace(/(^\s*)|(\s*$)/gi, "");
                          const newerData = newData.replace(/[ ]{2,}/gi, " ");
                          if (newerData.split(" ")?.length <= 100) {
                            setComments(e.target.value);
                          }
                        }}
                        fullWidth
                        multiline
                        placeholder={"Enter max 100 words"}
                      />
                      {feedBackData && feedBackData !== null ? (
                        ""
                      ) : (
                        <Typography className="commentwordcount">
                          Word Count:{" "}
                          {comments?.length === 0
                            ? 0
                            : comments
                                ?.replace(/(^\s*)|(\s*$)/gi, "")
                                ?.replace(/[ ]{2,}/gi, " ")
                                ?.split(" ")?.length}
                          /100
                        </Typography>
                      )}
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            )}
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-center" style={modelOverLap && modelOverLap === true ? {boxShadow:"0px 10px 5px #888"}:{}}>
            <div className="d-flex justify-between feedBackFooterFix">
              {((feedBackData !== undefined &&
              feedBackData !== null &&
              feedBackData !== "") || cohortAdminId == currentUserId) ? (
                <Button
                  onClick={handleClose}
                  text="CLOSE"
                  className="modalButton3 doc-upload"
                ></Button>
              ) : (
                <>
                  <div>
                    <Button
                      onClick={handleClose}
                      text="BACK"
                      className="modalButton3 doc-upload"
                    ></Button>
                  </div>
                  <div>
                    <Button
                      onClick={() => {
                        if (cohortSession && cohortSession === true) {
                          handleSubmitInvitation();
                        } else {
                          handleSubmit();
                        }
                      }}
                      text="SUBMIT"
                      className="modalButton3 doc-uploadnext"
                    ></Button>
                  </div>
                </>
              )}
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
  };
};

export default connect(mapStateToProps, { postMentorFeedback })(
  withRouter(StartupFeedbackModal)
);
